import "./ManageCollections.css";
import { useSelector } from "react-redux";
import { selectCollections } from "../../redux/features/appData";
import { CollectionCardTable } from "./CollectionCardTable";

export const ManageCollections = () => {
  const collections = useSelector(selectCollections);

  return (
    <div id="manage-collections">
      <div className="page-title">My Collections</div>
      {/* <div className="manage-collections-description">
                Do some stuff with your collections
            </div> */}

      <div className="manage-collections-container">
        <CollectionCardTable key={"collection-card-table"} />
      </div>
    </div>
  );
};
